import { API } from "../../../services";
import { handleResponse } from "../../../helpers";
import { API_URL } from "../../../config/appConfig";

const toRoleName = (role) => {
  if (!role) return "";
  if (typeof role === "string") return role;
  return role.name || role.role || role.roleName || "";
};

const getAllRoles = async () => {
  try {
    const response = await API.get(
      `${API_URL.idp}/system/role`,
      "roles_list"
    ).then(handleResponse);

    const list = Array.isArray(response)
      ? response
      : Array.isArray(response?.roles)
        ? response.roles
        : Array.isArray(response?.data)
          ? response.data
          : [];

    return list.map(toRoleName).filter(Boolean);
  } catch {
    return [];
  }
};

export const roleService = {
  getAllRoles,
};
